import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { TextField, IconButton } from '@totalsoft/rocket-ui';
import Search from '@mui/icons-material/Search';
import Close from '@mui/icons-material/Close';

const SearchComponent = ({ filter, onFilterValueChanged, handleResetFilters }) => {
  const [t] = useTranslation();

  return (
    <TextField
      id={'offerPartnerManualInterrogationModal_filters_fullText'}
      fullWidth
      name='filter'
      value={filter}
      onChange={e => onFilterValueChanged(e, true)}
      placeholder={t('Placeholders.ManualVerificationSearch')}
      startAdornment={<Search />}
      endAdornment={
        <IconButton
          onClick={handleResetFilters}
          disabled={!filter}
          id={'offerPartnerManualInterrogationModal_filters_resetBtn'}
          tooltip={t('Tooltips.ResetFilters')}
          color={'transparent'}
        >
          <Close />
        </IconButton>
      }
    />
  );
};

SearchComponent.propTypes = {
  filter: PropTypes.string.isRequired,
  onFilterValueChanged: PropTypes.func.isRequired,
  handleResetFilters: PropTypes.func.isRequired
};

export default SearchComponent;
